<template>
	<div>
		<!-- 产品信息 productinfor -->
		<div class="btn_box Flexalign" v-if="!isshow">
			<div class="customBtn FlexRow" style="width: 85px;" @click="addtinfor">
				<i class="el-icon-plus"></i>
				添加
			</div>
			<div class="customBtn FlexRow style2" @click="batchdele" :class="{'isdisabled': check_list.length < 1}">
				删除
			</div>
		</div>


		<div class="table_box" :style="tablestyle">
			<table border="0" cellpadding="0" cellspacing="0">
				<!-- 表头 -->
				<tr class="tr_th">
					<!-- 全选框 -->
					<th class="scrollCheck">
						<div class="check_box" v-if="!isshow">
							<el-checkbox :indeterminate="list_isIndeter" v-model="list_allchecked"
								@change="$forceUpdate(),th_headchange($event,0)">
							</el-checkbox>
						</div>
					</th>
					<!-- 表头信息 -->
					<th v-for="(thVal, thInd) in tableColumn" v-if="thVal.show">
						<div :style="`width:${thVal.width}px`">
							{{thVal.name}}
						</div>
					</th>
					<!-- 操作 -->
					<th class="scrolloper" v-if="!isshow">
						操作
					</th>
					<!-- 列设置 -->
					<th class="scrollSet">
						<div class="set_icon " @click="nset_show = true">
							<i class="el-icon-setting"></i>
						</div>
					</th>
				</tr>
				<!--  -->
				<!-- 表体 -->
				<tr class="tr_td" v-for="(item1, index1) in tablelist">
					<!-- 单选框 -->
					<td class="scrollCheck trbg2">
						<div class="check_box" v-if="!isshow">
							<el-checkbox v-model="item1.checked" @change="$forceUpdate(),td_headchange($event,index1)">
							</el-checkbox>
						</div>
					</td>
					<!-- 表格信息 -->
					<td v-for="(item2, index2) in tableColumn" v-if="item2.show">
						<div :style="`width:${item2.width}px`">
							<!-- 选择产品  v-loadMore="loadMore"  -->
							<template v-if="item2.prop == 'details_id'">
								<el-select :disabled="isshow" @change="goodsChange($event, index1)"
									v-model="item1.details_id"clearable filterable
									placeholder="选择产品">
									<el-option v-for="val in productlist" :key="val.details_id" :label="val.newSpecName"
										:value="val.details_id">
									</el-option>
								</el-select>
							</template> 
							
							<!-- 数量 -->
							<template v-else-if="item2.prop == 'goods_num'">
								<el-input @change="satisfyComputed" min="1" max="99999" :oninput="oninput"
									v-model="item1.goods_num" :disabled="isshow" clearable>
								</el-input>
							</template>

							<!-- 单价 -->
							<template v-else-if="item2.prop == 'goods_price'">
								<el-input @change="satisfyComputed" min="1" :oninput="oninput"
									v-model="item1.goods_price" :disabled="isshow" clearable>
								</el-input>
							</template>
							<!-- 折扣率% -->
							<template v-else-if="item2.prop == 'discount_rate'">
								<el-input @change="satisfyComputed" :min="1" :max="100" placeholder="0~100"
									:oninput="oninput" v-model="item1.discount_rate" :disabled="isshow" clearable>
								</el-input>
							</template>
							<!-- 增值税税率% -->
							<template v-else-if="item2.prop == 'vat_rate'">
								<el-input @change="satisfyComputed" min="1" max="100" placeholder="0~100"
									:oninput="oninput" v-model="item1.vat_rate" :disabled="isshow" clearable>
								</el-input>
							</template>
							<!-- 产品备注 -->
							<template v-else-if="item2.prop == 'remarks'">
								<el-input v-model="item1.remarks" :disabled="isshow" clearable placeholder="请输入内容"
									maxlength="30" show-word-limit>
								</el-input>
							</template>
							<!-- 产品附件 name path -->
							<template v-else-if="item2.prop == 'accesso'">
								<!-- 无附件信息 imgSrc -->
								<div v-show="!item1.accesso" style="width: 244px;overflow: hidden;"
									:class="{'isdisabled': isshow}">
									<enclofile ref="upfile" :listshow="false" @setupfile="fnsetfile($event, index1)"
										:flag.sync="fileflag"></enclofile>
								</div>
								<!-- 有附件信息 -->
								<div v-show="item1.accesso" class="file_box Flexalign" :class="{'isdisabled': isshow}">
									<div class="file_icon" v-if="item1.accesso.imgSrc">
										<img :src="item1.accesso.imgSrc" alt="">
									</div>
									<div class="file_name Singlerow" :title="item1.accesso.original_name">
										{{item1.accesso.original_name || ''}}
									</div>
									<div class="file_del" @click="delfile(index1)">
										<i class="el-icon-error"></i>
									</div>
								</div>
							</template>
							<!-- 显示信息 -->
							<template v-else>
								<div class="Singlerow" :title="item1[item2.prop]">
									{{item1[item2.prop]}}
								</div>
							</template>
						</div>
					</td>
					<!-- 操作 -->
					<td class="scrolloper trbg2" v-if="!isshow">
						<span class="delspan" @click="deledatas(index1)">
							删除
						</span>
					</td>
					<!-- 列设置 -->
					<td class="scrollSet trbg2"></td>
				</tr>
				<!-- <tr v-if="tablelist.length == 0">
					<td>
						暂无数据
					</td>
				</tr> -->
				<!--  -->
				<!-- 底部合计 -->
				<tr class="tr_bot" v-show="tablelist.length">
					<td class="scrollCheck">
						合计
					</td>
					<td v-for="(thVal, thInd) in tableColumn" v-if="thVal.show">
						<div :style="`width:${thVal.width}px`">
							{{thVal.botVal}}
						</div>
					</td>
					<td class="scrolloper" v-if="!isshow"></td>
					<td class="scrollSet"></td>
				</tr>
				<!--  -->
			</table>
		</div>
		<!--  -->
		<!-- 列设置 弹出   -->
		<columnset :show.sync="nset_show" :types="2" :columnlist="tableColumn" :defaultColumn="defaultColumn"
			@success="getCustomres"></columnset>
		<!--  -->



	</div>
</template>

<script>
	// 表格
	import tabcontainer from "@/components/tabledata/tabcontainer.vue";
	// 列设置 弹出
	import columnset from "./columnset.vue";
	// 上传附件
	import enclofile from "./enclofile.vue";
	import {
		handlereq,
		retujudpower,
		retupower,
		alertMess,
		retfieldPower,
		fn_fielddisabled,
		fnCustomPage,
		exportExcel,
		formatCurrency,
		kh_customer_list,

		bytesToSize,
		getFileType_,
		getspecDetailsList,
	} from 'network/kh_public'
	import {
		getGoodsLis2,
	} from 'network/hk_goods'
	import {
		get_order_compute,
		getCustomFeatures,
		get_goods_unit_list,
	} from 'network/hk_order'
	import {
		setupfile,
		getCurrentTime,
	} from 'network/hk_operset'
	export default {
		name: 'productinfor',
		props: {
			fieldlist: {
				type: Array,
				default: () => {
					return []
				}
			},
			goodslist: {
				type: Array,
				default: () => {
					return []
				}
			},
			classtype: {
				type: Number,
				default: 1,
			},
			flag: {
				type: Boolean,
				default: false,
			},
			isshow: {
				type: Boolean,
				default: false,
			},
			ispup: {
				type: Boolean,
				default: false,
			},
			
		},
		components: {
			tabcontainer,
			columnset,
			enclofile,
		},
		methods: {
			// 获取订单自定义
			getCustomres() {
				let resArr = getCustomFeatures(2)
				if (resArr && resArr.length) {
					this.tableColumn = resArr
					this.BottomTotal(this.Columndatas)
				} else {
					this.tableColumn = JSON.parse(JSON.stringify(this.defaultColumn))
				}
			},
			gnmentcompa(e) {
				this.Columndatas = e
				if (e) {
					let goods_info = e.goods_info || [];
					let dataArr = this.tablelist.filter(v => v.details_id && v.goods_num && v.goods_price)
					if (dataArr.length == goods_info.length) {
						for (let i = 0; i < goods_info.length; i++) {
							for (var key in goods_info[i]) {
								dataArr[i][key] = goods_info[i][key]
								this.$forceUpdate()
							}
						}
					}
					this.BottomTotal(e)
				}
			},
			// 底部合计
			BottomTotal(Columndatas) {
				let num = 0
				for (let item of this.tablelist) {
					let n = item.goods_num * 1
					if (n > 0) {
						num += n
					}
				}
				let index = this.tableColumn.findIndex(v => v.prop == 'goods_num')
				if (index != -1 && this.tableColumn[index]) {
					this.tableColumn[index].botVal = num
				}

				if (Columndatas) {
					// 底部合计
					for (let item of this.tableColumn) {
						for (let keys in Columndatas) {
							if (item.prop == keys) {
								if (item.prop != 'discount_rate') {
									item.botVal = Columndatas[keys]
								}

							}
						}
					}
				}

			},
			// 
			satisfyComputed() {
				let flag = this.tablelist.every(v => v.goods_id && v.details_id && v.discount_rate <= 100 && v.vat_rate <= 100 && v.goods_num > 0 && v.goods_price > 0)
				if (flag) {
					this.BottomTotal()
					let data = {} 
					if(this.classtype == 1) {
						data.order_goods = JSON.parse(JSON.stringify(this.tablelist))
					}
					else if(this.classtype == 2) {
						data.quotation_goods = JSON.parse(JSON.stringify(this.tablelist))
					}
					this.$emit('satisfy', data)
				}
			},
			// 设置产品信息列表
			setGoodlist() {
				this.tablelist = []
				if (this.goodslist && this.goodslist.length) {
					let index = 0
					for (let item of this.goodslist) {

						if (item.goods_info && typeof(item.goods_info) == 'string') {
							let JsgoodsInfo = JSON.parse(item.goods_info)
							// 产品备注
							let index1 = JsgoodsInfo.findIndex(v => v.field_sign == '产品备注')
							if (index1 != -1 && JsgoodsInfo[index1]) {
								item.remarks = JsgoodsInfo[index1].content
							}
							// 产品附件
							let index2 = JsgoodsInfo.findIndex(v => v.field_sign == '产品附件')
							if (index2 != -1 && JsgoodsInfo[index2]) {
								item.accesso = JsgoodsInfo[index2].content
							}
						}
						let newEle = JSON.parse(JSON.stringify(this.addEle))
						newEle.id = this.current_id
						newEle.checked = false

						for (let key in item) {
							
							if (key == 'unit') {  // 设置产品单位
								let str1 = item[key]
								let str2 = ''
								if (item.goods_unit && typeof(item.goods_unit) == 'string') { // 多单位
									let Js_unit = JSON.parse(item.goods_unit)
									let textarr = []
									for (let item of Js_unit) {
										if (item.unnit_id) {
											let curstr = `1${this.fn_findfont(item.unnit_id)}=${item.unit}${str1}`
											textarr.push(curstr)
										}
									}
									if (textarr.length) {
										str2 = `(${textarr.join(',')})`
									}
								}
								newEle[key] = `${str1} ${str2}`
								
							} else {
								newEle[key] = item[key]
							}

						}
						this.tablelist.push(newEle)
						this.current_id += 1
						index += 1
					}
				}
				this.BottomTotal()
				this.$emit('completeset')
				this.$forceUpdate()
			},


			exportres() {
				if (this.tablelist.length) {
					// 产品字段列表  

					let flag = this.tablelist.every(v => v.goods_id && v.details_id && v.goods_num > 0 && v.goods_price > 0)
					if (!flag) {
						alertMess('产品，数量和单价不能为空', 'error')
						this.$emit('update:flag', false)
					} else {
						this.fn_savefile()
					}
				} else {
					alertMess('最少添加一条产品信息', 'error')
					this.$emit('update:flag', false)
				}

			},
			// 添加产品附件
			fnsetfile(e, index) {
				if (e) {
					if (this.tablelist[index]) {
						this.tablelist[index].accesso = e.newArr ? e.newArr[0] : '';
						this.$forceUpdate()
					}
				}
			},
			fn_savefile() {

				this.fileuplen = 0
				let arr = this.tablelist.filter(v => v.accesso.raw)
				if (arr.length) {
					this.$emit('update:flag', false)
					this.flielen = arr.length;
					for (let i = 0; i < this.tablelist.length; i++) {
						let item = this.tablelist[i]
						if (item.accesso && item.accesso.raw) {
							this.fn_setupsfile(item.accesso, i)
						}
					}
				} else {
					this.exportlist()
				}
			},
			fn_setupsfile(file, index) {

				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let fd = new FormData()
				fd.append('store_id', this.$store.state.store_id)
				fd.append('file_name', file.name)
				fd.append('file[]', file.raw)


				setupfile(fd).then(res => {
					if (res.result) {
						let obj = res.result[0] // 返回的文件信息
						// 
						if (handlereq(res)) {

							let ele = {
								original_name: obj.original_name, //文件名
								path: obj.file_url || "", // 文件地址
								fileSize: bytesToSize(file.size),
								member_name: this.$store.state.member_name,
								create_time: getCurrentTime(),
								file_type: obj.file_type,
							}
							if (obj.file_type == 0) {
								ele.imgSrc = obj.file_url // 文件图标
							} else {
								ele.imgSrc = getFileType_(obj) // 文件图标
							}
							this.tablelist[index].accesso = ele
							// 
							this.fileuplen += 1
							if (this.fileuplen == this.flielen) {
								this.fileuplen = 0
								this.flielen = 0

								this.exportlist()
							}
						}
					}


					loading.close();

				})
			},
			// 删除产品附件
			delfile(index) {
				if (this.tablelist[index]) {
					this.tablelist[index].accesso = ''
					this.$forceUpdate()
				}
			},
			// 输出结果
			exportlist() {
				let fieldlist = JSON.parse(JSON.stringify(this.fieldlist))
				let flag2 = this.tablelist.every(v => v.discount_rate <= 100 && v.vat_rate <= 100)
				if (flag2) {
					let goodsIdArr = []
					let detailsIdArr = []
					let outer_info = [] // 外层数据
					// 表格列表数据
					for (let item of this.tablelist) {
						let inlayer = []
						let newEle = {
							details_id: item.details_id, // 规格详情id
							goods_id: item.goods_id, // 产品id
							goods_num: item.goods_num, // 产品数量
							goods_price: item.goods_price, // 产品单价
							discount_rate: item.discount_rate, // 折扣率
							vat_rate: item.vat_rate, // 增值税税率
							goods_info: '', // 内层字段
						}
						if (item.og_id) {
							newEle.og_id = item.og_id
						}
						// 分离产品Id
						goodsIdArr.push(item.goods_id)
						// 规格详情id
						detailsIdArr.push(item.details_id)
						for (let value of fieldlist) {
							let inla_obj = {
								field_id: value.field_id,
								content: '',
								field_sign: value.field_sign,
								// field_type: value.field_type,
							}
							if (value.field_sign == '产品名称') {
								inla_obj.content = item.goods_id
							} else if (value.field_sign == '产品数量') {
								inla_obj.content = item.goods_num
							} else if (value.field_sign == '产品单价') {
								inla_obj.content = item.goods_price
							} else if (value.field_sign == '折扣率') {
								inla_obj.content = item.discount_rate
							} else if (value.field_sign == '增值税税率') {
								inla_obj.content = item.vat_rate
							} else if (value.field_sign == '产品备注') {
								inla_obj.content = item.remarks
							} else if (value.field_sign == '产品附件') {
								inla_obj.content = item.accesso
							}
							inlayer.push(inla_obj)
						}
						newEle.goods_info = JSON.stringify(inlayer)
						outer_info.push(newEle)
					}

					let data = {
						res: outer_info,
						goods_id: goodsIdArr.join(','),
						details_id: detailsIdArr.join(','),
					}

					this.$emit('update:flag', true)
					this.$emit('fnexport', data)

				} else {
					alertMess('折扣率，增值税税率应为0~100', 'error')
					this.$emit('update:flag', false)
				}



			},
			// 查询字段
			findField_Info(field_sign) {
				let res = ''
				let index = this.FieldInitial.findIndex(v => v.field_sign == field_sign)
				if (index != -1 && this.FieldInitial[index]) {
					res = this.FieldInitial[index]
				}
				return res;
			},


			// 初始化
			// 勾选表格
			handleSelectionChange(val) {
				let list = this.tablelist.filter(v => v.checked)
				this.check_list = JSON.parse(JSON.stringify(list))
			},
			// 表格头部多选
			th_headchange(e) {
				if (this.list_allchecked) {
					for (let item of this.tablelist) {
						item.checked = true
					}
					this.list_isIndeter = false
					this.list_allchecked = true
				} else if (!this.list_allchecked) {
					for (let item of this.tablelist) {
						item.checked = false
					}
					this.list_isIndeter = false
					this.list_allchecked = false
				} else if (this.list_isIndeter) {
					for (let item of this.tablelist) {
						item.checked = true
					}
					this.list_isIndeter = false
					this.list_allchecked = true
				}
				this.handleSelectionChange()
			},
			// 表格行单选
			td_headchange(e, index) {
				let allflag = this.tablelist.every(v => v.checked)
				if (allflag) {
					this.list_isIndeter = false
					this.list_allchecked = true
				} else {
					let oneflag = this.tablelist.some(v => v.checked)
					if (oneflag) {
						this.list_isIndeter = true
						this.list_allchecked = false
					} else {
						this.list_isIndeter = false
						this.list_allchecked = false
					}
				}
				this.handleSelectionChange()
			},
			// 获取屏幕宽度，动态设置表格宽度
			getvanhe() {
				setTimeout(() => {
					if(this.ispup) {
						this.tablestyle = `width: ${927}px`
					}
					else {
						if (!this.isshow) {
							let iscollect = this.$store.state.iscollect
							let h1 = document.documentElement.clientWidth
							if (iscollect) {
								this.tablestyle = `width: ${h1 - 130}px`
							} else {
								this.tablestyle = `width: ${h1 - 276}px`
							}
						} else {
							this.tablestyle = `width: ${774 - 58}px`
						}
					}
				}, 300)
			},
			// 删除一行
			deledatas(index) {
				this.tablelist.splice(index, 1)
				this.satisfyComputed()
				this.fncleartable()
			},
			// 批量删除 
			batchdele() {
				if (this.check_list.length) {
					for (let item of this.check_list) {
						let index = this.tablelist.findIndex(v => v.id == item.id)
						if (index != -1 && this.tablelist[index]) {
							this.tablelist.splice(index, 1)
						}
					}
				}

				this.satisfyComputed()
				this.fncleartable()
			},

			fncleartable() {
				this.list_isIndeter = false
				this.list_allchecked = false
				if (this.tablelist.length) {
					for (let item of this.tablelist) {
						item.checked = false
					}
				}
			},
			// 新增产品信息
			addtinfor() {
				this.current_id += 1
				let newEle = JSON.parse(JSON.stringify(this.addEle))
				newEle.id = this.current_id
				this.tablelist.push(newEle)
			},
			// 检测选择产品是否有相同
			goodsChange(e, index) {
				if (this.tablelist[index]) {
					this.tablelist[index].goods_num = ''
					this.tablelist[index].goods_price = ''
					this.tablelist[index].remarks = ''
					this.tablelist[index].discount_rate = ''
					this.tablelist[index].vat_rate = ''
					this.tablelist[index].accesso = ''
					this.tablelist[index].goods_code = ''
					this.tablelist[index].unit = ''
					
				}
				if (e) {
					
					let arr = this.tablelist.filter(v => v.details_id == e)
					if (arr.length > 1) {
						alertMess('已有相同规格产品', 'warning')
					}
					let index1 = this.productlist.findIndex(v => v.details_id == e)
					if (index1 != -1 && this.productlist[index1]) {
						let obj1 = this.productlist[index1]
						if (this.tablelist[index]) {
							let price = 0
							if (obj1.price_type == 1) { // 设置产品价格
								
								if(obj1.is_spec == 1) {  // 多规格
									price = obj1.price || ''
								}
								else {  // 不是多规格
									price = obj1.goods_price || ''
								}
								
							}
							else {  // 价格面议
								price = obj1.goods_price || ''
							}
							
							this.tablelist[index].goods_price = price
							this.tablelist[index].goods_code = obj1.code || ''
							this.tablelist[index].goods_num = 1
							this.tablelist[index].goods_id = obj1.goods_id
						}
						
						// 设置产品单位
						if (obj1.unit_id) {
							let str1 = ''
							let str2 = ''
							str1 = this.fn_findfont(obj1.unit_id)
							if (obj1.unit && typeof(obj1.unit) == 'string') { // 多单位
								let Js_unit = JSON.parse(obj1.unit)
								let textarr = []
								for (let item of Js_unit) {
									if (item.unnit_id) {
										let curstr = `1${this.fn_findfont(item.unnit_id)}=${item.unit}${str1}`
										textarr.push(curstr)
									}
								}
								if (textarr.length) {
									str2 = `(${textarr.join(',')})`
								}
							}
							this.tablelist[index].unit = `${str1} ${str2}`
						}
						
					
					}
				}

				this.BottomTotal()
				this.satisfyComputed()
			},
			fn_findfont(unit_id) {
				let res = ''
				if (unit_id) {
					let arr = this.unitList.filter(v => v.unit_id == unit_id)
					if (arr && arr[0]) {
						res = arr[0].name
					}
				}
				return res;
			},
			// 获取产品和规格  details_id
			getGoodsList(){
				let data = {
					pagesize: 999,
				}
				getspecDetailsList(data).then(res=>{
					if (handlereq(res)) {
						let obj = res.result.data || []
						if(obj.length) {
							for(let item of obj) {
								let newVal = ''
								if(item.value_name && typeof(item.value_name) == 'string') {
									let newObj = JSON.parse(item.value_name)
									newVal = newObj.length ? newObj.join(',') : '';
								}
								if(item.is_spec == 1) {
									item.newSpecName = `${item.name}-${newVal}`
								}
								else {
									item.newSpecName = `${item.name}`
								}
							}
						}
						this.productlist = obj
					}
				})
			},
			
			// 获取单位列表
			getunit_list() {
				let data = {
					pagesize: 999, //  	是	int	每页数量
					page: 1,
				}
				get_goods_unit_list(data).then(res => {
					if (handlereq(res)) {
						let obj = res.result.data
						this.unitList = obj
					}
				})
			},
			// 自定义事件，滚动条触底时触发 获取产品  
			// loadMore() {
			// 	if (this.goods.page < this.goods.last_page) {
			// 		this.goods.page += 1
			// 		this.getGood sList()
			// 	}
			// },

		},
		directives: { // 在组件中接受一个 directives 的选项
			loadMore: {
				inserted(el, binding) {
					const dom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap'); // 获取下拉框元素
					dom.addEventListener('scroll', function() { // 监听元素触底
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				},
			},
		},
		watch: {
			// 监听左侧导航栏是否收起，收起就设置表格宽度
			'$store.state.iscollect'(newVal, oldVal) {

				this.getvanhe()
			},
			goodslist() {
				this.setGoodlist()
			},
			isshow(){
				console.log(this.goodslist,'goodslist')
			},
		},
		//页面销毁前解除监听
		destroyed() {
			window.onresize = null;
		},
		created() {
			this.getunit_list()
			// 设置表格宽度
			this.getvanhe()
			if (!this.isshow) {
				window.onresize = () => {
					this.getvanhe()
				}
			}
			if (this.goodslist.length == 0) {
				// 添加一条信息
				this.addtinfor()
			}

			// 获取产品列表
			this.getGoodsList()
			// 获取表格表头
			this.getCustomres()
			
			this.setGoodlist()
		},
		data() {
			return {
				speclist: [],
				
				fileuplen: 0,
				flielen: 0,
				fileflag: false,

				unitList: [],

				Columndatas: '',

				addEle: {
					goods_code: '',
					goods_id: '',
					details_id: '',
					unit: '',
				
					goods_num: '',
					goods_price: '',
					discount_rate: '',
					vat_rate: '',
					sjhsdj_price: '',
					jshj_price: '',
					zqje_price: '',
					zke_price: '',
					hszke_price: '',
					zhdj_price: '',
					zhje_price: '',
					se_price: '',
					sjbhsdj_price: '',
					sjhsdj_price: '',
					jshj_price: '',
					remarks: '',
					accesso: '',
				},
				// 
				current_id: 1,
				// 
				oninput: "value=value.replace(/[^0-9.]/g,'')",
				// 
				list_isIndeter: false,
				list_allchecked: false,
				// 
				tablestyle: '',

				// 产品列表
				productlist: [],
				goods: {
					pagesize: 50,
					page: 1,
					last_page: 0,
				},
				// 
				nset_show: false,
				// 列表 ------------------
				cellstyle: {
					background: 'rgb(249,249,249)',
				},
				rowstyle: {
					height: '60px',
				},
				table_loading: false, // 加载中
				tablelist: [], // 列表数据
				check_list: [], // 多选
				// 表格 表头
				tableColumn: [],
				defaultColumn: [{
						prop: 'goods_code',
						name: '产品编码',
						width: 145,
						show: true,
					},
					{
						prop: 'details_id',
						
						name: '产品名称',
						width: 150,
						disabled: true,
						show: true,
					},
					{
						prop: 'unit',
						name: '单位',
						width: 180,
						show: true,
					},


					{
						prop: 'goods_num',
						name: '数量',
						width: 105,
						botVal: '',
						disabled: true,
						show: true,
					},
					{
						prop: 'goods_price',
						name: '单价(￥)',
						width: 110,
						disabled: true,
						show: true,
					},
					
					{
						prop: 'discount_rate',
						name: '折扣率(%)',
						width: 110,
						disabled: true,
						show: true,
					},
					{

						prop: 'vat_rate',
						name: '增值税税率(%)',
						width: 110,
						disabled: true,
						show: true,
					},
					{
						prop: 'sjhsdj_price',
						name: '实际含税单价(￥)',
						width: 105,
						show: true,
					},
					{

						prop: 'jshj_price',
						name: '价税合计(￥)',
						width: 80,
						botVal: '',
						show: true,
					},
					// ------
					{
						prop: 'zqje_price',
						name: '折前金额(￥)',
						width: 120,
						botVal: '',
						show: false,
					},
					{
						prop: 'zke_price',
						name: '折扣额(￥)',
						width: 120,
						botVal: '',
						show: false,
					},
					{
						prop: 'hszke_price',
						name: '含税折扣额(￥)',
						width: 120,
						botVal: '',
						show: false,
					},
					{
						prop: 'zhdj_price',
						name: '折后单价(￥)',
						width: 120,
						botVal: '',
						show: false,
					},
					{
						prop: 'zhje_price',
						name: '折后金额(￥)',
						width: 120,
						botVal: '',
						show: false,
					},
					{
						prop: 'se_price',
						name: '税额(￥)',
						width: 120,
						botVal: '',
						show: false,
					},
					{
						prop: 'sjbhsdj_price',
						name: '实际不含税单价(￥)',
						width: 120,
						botVal: '',
						show: false,
					},
					{
						prop: 'sjhsdj_price',
						name: '实际含税单价(￥)',
						width: 150,
						botVal: '',
						show: false,
					},
					{
						prop: 'jshj_price',
						name: '价税合计(￥)',
						width: 150,
						botVal: '',
						show: false,
					},
					{
						prop: 'remarks',
						name: '产品备注',
						width: 250,
						show: false,
					},
					{
						prop: 'accesso',
						name: '产品附件',
						width: 250,
						show: false,
					},



				],
				// ------------------
			}
		},


	}
</script>

<style lang="scss" scoped>
	.trbg1 {
		background: rgba(249, 249, 249, 1) !important;
	}

	.trbg2 {
		background: #fff !important;
	}

	.scrollSet {
		position: sticky;
		right: 0;
		z-index: 10;
		background: rgba(249, 249, 249, 1);
	}

	.scrolloper {
		position: sticky;
		right: 28px;
		z-index: 10;
		background-color: rgba(249, 249, 249, 1);
	}

	.scrollCheck {
		position: sticky;
		left: 0px;
		text-align: center !important;
		z-index: 10;
		background-color: rgba(249, 249, 249, 1);
	}

	.check_box {
		padding: 0 10px;
	}

	.table_box {
		width: 100%;
		overflow: auto;

		table {
			width: 100%;
			// border:solid 1px red;
		}

		.tr_th,
		.tr_bot {
			background: rgba(249, 249, 249, 1);

			th,
			td {
				height: 39px;
				font-size: 14px;
				font-weight: 550;
				color: rgba(56, 56, 56, 1);
				text-align: left;
				vertical-align: center;
				padding: 0 6px;
				white-space: nowrap;
			}
		}

		.tr_td {
			border-bottom: solid 1px rgba(235, 238, 245, 1) !important;
			border-color: rgba(235, 238, 245, 1) !important;

			td {
				border-bottom: solid 1px rgba(235, 238, 245, 1) !important;
				border-color: rgba(235, 238, 245, 1) !important;
				white-space: nowrap;
				padding: 0 6px;
				height: 60px;
				font-size: 14px;
				font-weight: 400;
				color: rgba(96, 98, 102, 1);
				text-align: left;
				vertical-align: center;
			}
		}



		.file_box {
			width: 244px;
			height: 32px;
			border-radius: 2px;
			background: rgba(255, 255, 255, 1);
			border: 1px solid rgba(223, 225, 232, 1);
			padding: 0 8px;

			.file_icon {
				width: 22px;
				height: 22px;
				border-radius: 2px;
				margin-right: 8px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.file_name {
				flex: 1;
				max-width: 185px;
			}

			.file_del {
				color: rgba(229, 229, 229, 1);
				font-size: 18px;
				cursor: pointer;
			}

			.file_del:hover {
				color: #ff401a;
			}
		}

	}

	.delspan {

		cursor: pointer;
		font-size: 14px;
		font-weight: 400;
		color: rgba(43, 117, 235, 1);
		text-align: left;
		vertical-align: top;
	}

	.btn_box {
		margin-bottom: 20px;
	}
</style>